module.exports = "/images/fga_cover_011723.png?02af080ab743057f809419b908f80d4a";